import { useState } from "react";
import brochures from "../data/brochures";
import PdfThumbnail from "../components/PdfThumbnail";
import { useEffect } from "react";

let brochurePageLoaded = false;

export default function BrochurePage() {
  const [activeBrochure, setActiveBrochure] = useState(null);
  const [loading, setLoading] = useState(!brochurePageLoaded);

  useEffect(() => {
    if (!brochurePageLoaded) {
      const timer = setTimeout(() => {
        brochurePageLoaded = true;
        setLoading(false);
      }, 400);
      return () => clearTimeout(timer);
    }
  }, []);

  const isMobile = () =>
    typeof window !== "undefined" && window.innerWidth < 768;

  const openBrochure = (item) => {
    const url = `${process.env.PUBLIC_URL}/img/s-product/${item.pdf}`;
    if (isMobile()) {
      window.open(url, "_blank", "noopener,noreferrer");
      return;
    }
    setActiveBrochure(item);
  };

  const closeBrochure = () => setActiveBrochure(null);
  const pdfUrl = activeBrochure
    ? `${process.env.PUBLIC_URL}/img/s-product/${activeBrochure.pdf}`
    : null;

  if (loading) {
    return (
      <main className="bg-white min-h-screen font-sans antialiased text-gray-700">
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4">
            <div className="text-center mb-12 animate-pulse">
              <div className="h-4 bg-gray-200 rounded w-48 mx-auto mb-3"></div>
              <div className="h-8 bg-gray-200 rounded w-64 mx-auto mb-3"></div>
              <div className="h-4 bg-gray-200 rounded w-80 mx-auto"></div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
              {[...Array(5)].map((_, i) => (
                <div key={i} className="bg-white border border-gray-100 rounded-sm overflow-hidden shadow-sm animate-pulse p-4 space-y-4">
                  <div className="w-full h-48 bg-gray-200 rounded"></div>
                  <div className="h-5 bg-gray-200 rounded w-3/4"></div>
                  <div className="h-3 bg-gray-200 rounded w-full"></div>
                  <div className="h-4 bg-gray-200 rounded w-1/2"></div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
    );
  }

  return (
    <main className="bg-white min-h-screen font-sans antialiased text-gray-700">
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <p className="text-sm italic text-[#43a047] font-serif tracking-wide mb-1">
              Explore our catalogue
            </p>
            <h1 className="text-2xl md:text-3xl font-medium text-[#112244] tracking-wide">
              Product Brochures
            </h1>
            <p className="text-sm text-gray-500 max-w-xl mx-auto mt-3">
              Click any category below to open and view its brochure.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
            {brochures.map((item) => (
              <button
                key={item.slug}
                onClick={() => openBrochure(item)}
                className="group block text-left bg-white border border-gray-100 rounded-sm overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300"
              >
                <div className="relative overflow-hidden banner-thumb-effect">
                  <PdfThumbnail
                    pdfUrl={`${process.env.PUBLIC_URL}/img/s-product/${item.pdf}`}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#112244]/70 via-transparent to-transparent pointer-events-none" />
                 
                </div>

                <div className="p-4">
                  <h3 className="text-[#112244] font-medium text-base tracking-wide group-hover:text-[#43a047] transition-colors">
                    {item.name}
                  </h3>
                  <p className="text-xs text-gray-500 mt-1 line-clamp-2">
                    {item.tagline}
                  </p>
                  <span className="inline-flex items-center gap-1 text-[11px] font-bold uppercase tracking-wider text-[#43a047] mt-3">
                    View Brochure
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-3.5 h-3.5 group-hover:translate-x-1 transition-transform"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </span>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* PDF Modal */}
      {activeBrochure && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-4 md:p-8 bg-[#112244]/70 backdrop-blur-sm"
          onClick={closeBrochure}
        >
          <div
            className="bg-white w-full max-w-5xl h-[85vh] rounded-sm shadow-2xl overflow-hidden flex flex-col"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div className="flex items-center justify-between px-5 py-3 border-b border-gray-100 bg-white">
              <div>
                <h2 className="text-[#112244] font-medium text-base tracking-wide">
                  {activeBrochure.name} Brochure
                </h2>
                <p className="text-xs text-gray-500">
                  {activeBrochure.tagline}
                </p>
              </div>

              <div className="flex items-center gap-2">
                <a
                  href={pdfUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hidden sm:inline-flex items-center gap-1 border border-[#112244] text-[#112244] px-3 py-1.5 rounded-sm text-[11px] font-bold uppercase tracking-wider hover:bg-[#112244] hover:text-white transition-colors"
                >
                  Open in New Tab
                </a>

                <a
                  href={pdfUrl}
                  download
                  className="hidden sm:inline-flex items-center gap-1 bg-[#43a047] text-white px-3 py-1.5 rounded-sm text-[11px] font-bold uppercase tracking-wider hover:bg-[#112244] transition-colors"
                >
                  Download
                </a>

                <button
                  onClick={closeBrochure}
                  className="w-8 h-8 flex items-center justify-center rounded-full text-gray-500 hover:bg-gray-100 hover:text-[#112244] transition-colors"
                  aria-label="Close"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-4 h-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>

            {/* PDF Body */}
            <div className="flex-1 bg-gray-50">
              <object
                data={pdfUrl}
                type="application/pdf"
                width="100%"
                height="100%"
              >
                <div className="p-10 text-center text-sm text-gray-500">
                  Your browser can't display PDFs inline.{" "}
                  <a
                    href={pdfUrl}
                    className="text-[#43a047] font-medium underline"
                  >
                    Click here to download {activeBrochure.name} brochure
                  </a>
                  .
                </div>
              </object>
            </div>
          </div>
        </div>
      )}
    </main>
  );
}
